import { routes } from '~/components/app/appMainRoutes';

export const NEW_TARGET_MARKET_LIST = `${routes.targetMarkets}?new=true`;

export const EMPLOYEE_RANGES = [
  { label: '1-10', value: '1~10' },
  { label: '11-50', value: '11~50' },
  { label: '51-250', value: '51~250' },
  { label: '251-1K', value: '251~1000' },
  { label: '1K-5K', value: '1000~5000' },
  { label: '5K-10K', value: '5000~10000' },
  { label: '10K-50K', value: '10000~50000' },
  { label: '50K-100K', value: '50000~100000' },
  { label: '100K+', value: '100000~' },
];

export const BUSINESS_MODELS = [
  {
    label: 'B2B',
    value: 'B2B',
  },
  {
    label: 'B2C',
    value: 'B2C',
  },
];

export const COMPANY_TYPES = [
  { label: 'Education', value: 'education' },
  { label: 'Government', value: 'government' },
  { label: 'Non-profit', value: 'nonprofit' },
  { label: 'Private', value: 'private' },
  { label: 'Public', value: 'public' },
];

export const RAISED_RANGES = [
  { label: '$0-$1M', value: '0~1000000' },
  { label: '$1M-$10M', value: '1000001~10000000' },
  { label: '$10M-$50M', value: '10000001~50000000' },
  { label: '$50M-$100M', value: '50000001~100000000' },
  { label: '$100M+', value: '100000001~' },
];
